import React, { useState } from 'react';
import './services.css';
import { Services_Data } from '../../assets/Services_data.js';

const Services = () => {
  const [showAll, setShowAll] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [showModal, setShowModal] = useState(false);

  const handleReadMore = (desc) => {
    setModalContent(desc);
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  const visibleCards = showAll ? Services_Data.length : 3;

  return (
    <div id='services' className='services'>
      <div className="services-title">
        <h1>My Services</h1>
      </div>

      <div className="services-container">
        {Services_Data.slice(0, visibleCards).map((service, index) => (
          <div key={index} className="services-format">
            <h3>{service.s_no}</h3>
            <h2>{service.s_name}</h2>
            <p>{service.s_desc.slice(0, 60)}...</p>
            <div className="services-readmore" onClick={() => handleReadMore(service.s_desc)}>
              <p>Read More</p>
            </div>
          </div>
        ))}
      </div>

      <button
        className="nav-connect"
        onClick={() => setShowAll(!showAll)}
      >
        {showAll ? "Show Less" : "Show More"}
      </button>

      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <span className="modal-close" onClick={closeModal}>&times;</span>
            <p>{modalContent}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Services;
